import React from "react";
import { t } from 'helpers/i18n';

const BranchName: React.FC = () => {
  const message = t('branch_build_hint_text_title', {
    master: `<span style="font-weight: bold;">master</span>`,
    epic: `<span style="font-weight: bold;">epics/XYZ-NUMBER or epic/XYZ-NUMBER or features/XYZ-NUMBER or feature/XYZ-NUMBER</span>`,
    tasks: `<span style="font-weight: bold;">tasks/XYZ-NUMBER or task/XYZ-NUMBER or impr/XYZ-NUMBER</span>`,
  });
  return (
    <div dangerouslySetInnerHTML={{__html: message}}>

    </div>
  );
}

export default BranchName;